import React, {useEffect, useState} from 'react';
import PubSub from 'services/PubSub/';
import Drawer from "components/Drawers/Drawer";
import { actionsType } from 'config/constants';
import ProductsSimilar from 'components/Drawers/DrawerSimilarProducts/ProductsSimilar';
import WrapperOptimizer from 'components/WrapperOptimizer';
import style from './style.scss'; //NOSONAR

let actions = [];

const DrawerSimilarProducts = () => {
    const [skuId, setSkuId] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [categoryParent, setCategoryParent] = useState('');

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.SIMILAR_PRODUCTS_OPEN, _open));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const  _open = (payload) => {
        if(payload) {
            setSkuId(payload.value.skuId);
            setCategoryId(payload.value.categoryId);
            setCategoryParent(payload.value.categoryParent)
        }
    }

    return (
        <Drawer customClass={'drawer-similar-products'} actionOpen={actionsType.DRAWER.SIMILAR_PRODUCTS_OPEN} actionClose={actionsType.DRAWER.SIMILAR_PRODUCTS_CLOSE}>
            <WrapperOptimizer typeComponent="pdp_similar_products" >
                {(data) => <ProductsSimilar skuId={skuId} categoryId={categoryId} categoryParent={categoryParent} type={'category'} campaignData={data}/>}
            </WrapperOptimizer>
        </Drawer>
    );
}

export default DrawerSimilarProducts;
